var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "status-board" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "ph-left" }, [
          _vm._m(0),
          _c("div", { staticClass: "desc" }, [
            _c("span", [
              _vm._v(
                "实时展示 " +
                  _vm._s(_vm.states.length) +
                  " 个已服务州的税务资质 + 系统配置 双轨健康度"
              ),
            ]),
            _c("span", { staticClass: "desc-pt" }, [
              _vm._v(
                " Exibe em tempo real a saúde das duas trilhas (qualificação fiscal + configuração do sistema) dos " +
                  _vm._s(_vm.states.length) +
                  " estados atendidos "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("kpi-cards", {
        attrs: {
          states: _vm.states,
          "alert-today": _vm.alertToday,
          schedule: _vm.schedule,
          "service-total": _vm.serviceTotal,
          summary: _vm.kpi,
        },
        on: { jump: _vm.handleJump },
      }),
      _c("div", { staticClass: "alert alert-warn" }, [
        _c(
          "svg",
          {
            staticClass: "ico",
            attrs: {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
            },
          },
          [
            _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
            _c("path", { attrs: { d: "M12 7.4v5.6" } }),
            _c("circle", {
              attrs: {
                cx: "12",
                cy: "16.6",
                r: "1.15",
                fill: "currentColor",
                stroke: "none",
              },
            }),
          ]
        ),
        _c("span", { staticClass: "alert-text" }, [
          _c("span", [
            _vm._v(
              "北部 " +
                _vm._s(_vm.unmonitoredNum) +
                " 州（" +
                _vm._s(_vm.northText) +
                "）当前未对外报价，本次不纳入监控范围。如需扩展监控，请联系产品经理评估。"
            ),
          ]),
          _c("span", { staticClass: "alert-pt" }, [
            _vm._v(
              "Os " +
                _vm._s(_vm.unmonitoredNum) +
                " estados do Norte (" +
                _vm._s(_vm.northText) +
                ") não têm tarifas publicadas e ficam fora do monitoramento. Para expandir a cobertura, contate o gerente de produto."
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "board-grid" }, [
        _c("div", { staticClass: "card card-left" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h3", [
              _c("span", [
                _vm._v(_vm._s(_vm.states.length) + " 个已服务州 · 双轨健康度"),
              ]),
              _c("span", { staticClass: "h3-pt" }, [
                _vm._v(
                  _vm._s(_vm.states.length) +
                    " estados atendidos · saúde das duas trilhas"
                ),
              ]),
            ]),
            _c("div", { staticClass: "actions" }, [
              _c(
                "span",
                { staticClass: "tag tag-ok" },
                [
                  _c("span", { staticClass: "dot" }),
                  _c("bi-label", {
                    attrs: { zh: "税务正常", pt: "Normal (Fisco)", inline: "" },
                  }),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "tag tag-info" },
                [
                  _c("span", { staticClass: "dot" }),
                  _c("bi-label", {
                    attrs: {
                      zh: "系统已配置",
                      pt: "Sistema Configurado",
                      inline: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "tag tag-err" },
                [
                  _c("span", { staticClass: "dot" }),
                  _c("bi-label", {
                    attrs: { zh: "异常", pt: "Exceção", inline: "" },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("brazil-map", {
                attrs: {
                  states: _vm.states,
                  "ie-table": _vm.ieTable,
                  legend: _vm.mapLegend,
                  checking: _vm.checking,
                  "expire-warn-days": _vm.expireWarnDays,
                  "unmonitored-num": _vm.unmonitoredNum,
                  "unmonitored-uf": _vm.unmonitoredUf,
                },
                on: { select: _vm.openUfDetail },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "card card-right" }, [
          _c("div", { staticClass: "card-fill" }, [
            _c("div", { staticClass: "card-header" }, [
              _vm._m(1),
              _c(
                "a",
                {
                  staticClass: "link-more",
                  on: {
                    click: function ($event) {
                      return _vm.handleJump({ module: "alert-log" })
                    },
                  },
                },
                [
                  _c("bi-label", {
                    attrs: { zh: "查看全部", pt: "Ver Tudo", inline: "" },
                  }),
                  _vm._v(" › "),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "card-fill-body" }, [
              _vm._m(2),
              _c(
                "div",
                { staticClass: "anomaly-body" },
                [
                  _c("anomaly-list", {
                    attrs: { list: _vm.anomalies },
                    on: { view: _vm.openAnomalyDetail },
                  }),
                ],
                1
              ),
              _vm._m(3),
              _c(
                "div",
                { staticClass: "timeline-body" },
                [_c("alert-timeline", { attrs: { list: _vm.timeline } })],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _c("uf-detail-drawer", {
        attrs: {
          visible: _vm.drawerVisible,
          uf: _vm.drawerUf,
          detail: _vm.drawerDetail,
          "change-log": _vm.drawerChangeLog,
        },
        on: {
          "update:visible": function ($event) {
            _vm.drawerVisible = $event
          },
          check: _vm.handleCheckOne,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticStyle: { "margin-top": "0" } }, [
      _vm._v(" 开票主体状态监控看板 "),
      _c("span", { staticClass: "h2-pt" }, [
        _vm._v("Painel de Monitoramento de Status de Entidades Emissoras"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", [_vm._v("实时异常 / 告警")]),
      _c("span", { staticClass: "h3-pt" }, [
        _vm._v("Exceções / Alertas em Tempo Real"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-block" }, [
      _c("div", { staticClass: "sub-title" }, [
        _c("span", [_vm._v("异常主体清单")]),
        _c("span", { staticClass: "sub-pt" }, [
          _vm._v("Lista de Entidades com Exceção"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sub-block sub-title-body" }, [
      _c("div", { staticClass: "sub-title" }, [
        _c("span", [_vm._v("最近告警时间线")]),
        _c("span", { staticClass: "sub-pt" }, [
          _vm._v("Linha do Tempo de Alertas Recentes"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }